import { authenticatedFetch } from "./auth.api";

const BASE_URL = process.env.REACT_APP_ZVB_URL ;

// API to fetch all services including inactive ones
export const fetchAllServices = async () => {
  try {
    const response = await authenticatedFetch(`${BASE_URL}/allservices`);

    if (!response.ok) {
      throw new Error("Network response error.");
    }

    const data = await response.json();


    console.log("Fetched services data:", data);

    return Array.isArray(data) ? data : [];
  } catch (error) {
    console.error("Error fetching services:", error);
    return [];
  }
};


// API to update service status
export const updateServiceStatus = async (serviceId, status) => {
  const response = await authenticatedFetch(
    `${BASE_URL}/services/${serviceId}/status`,
    {
      method: "POST",
      body: JSON.stringify({ status }),
    }
  );

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || "Failed to update service status");
  }

  return response.json();
};

// API to update whole service details
export const updateService = async (serviceId, data) => {
  const res = await authenticatedFetch(`${BASE_URL}/services/${serviceId}`, {
    method: "PUT",
    body: JSON.stringify(data),
  });

  if (!res.ok) {
    const error = await res.json();
    throw new Error(error.message || "Failed to update service");
  }

  return res.json();
};

// API to add service.
export const addService = async (data) => {
  console.log(data);
  const res = await authenticatedFetch(`${BASE_URL}/services`, { // add endpoint here
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });

  if (!res.ok) {
    const error = await res.json();
    throw new Error(error.message || "Failed to add service");
  }
  console.log("Payload Received: ", data)
  return res.json();
};